import { render, staticRenderFns } from "./ManageColumnsSection.vue?vue&type=template&id=6832e180&scoped=true"
import script from "./ManageColumnsSection.vue?vue&type=script&lang=js"
export * from "./ManageColumnsSection.vue?vue&type=script&lang=js"
import style0 from "./ManageColumnsSection.vue?vue&type=style&index=0&id=6832e180&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6832e180",
  null
  
)

export default component.exports